export default __webpack_public_path__ + "static/media/icon-info.f614df75.svg";